<template lang="pug">
el-dialog(
  title="Novo pedido de assinatura",
  :visible="visible",
  @update:visible="emit('update:visible', $event)"
)

  el-form(ref="form", :model="data", :rules="rules", label-width="160px")

    el-form-item(label="Edição", prop="edition")
        RemoteSearchSelect(
        v-model="data.edition",
        :search-function="SubscriptionBoxEditionService.search",
        :find-function="SubscriptionBoxEditionService.find",
        :label-function="(item) => item.id"
        :value-function="(item) => item.id",
        :custom-options="{ orderBy: 'id', sortDirection: 'desc' }"
        placeholder="Selecione a edição deste pedido"
    )

    el-form-item(prop="shippingAddressId", label="Endereço de entrega")
      RemoteSearchSelect(
        v-model="data.shippingAddressId",
        :search-function="ShippingAddressService.search",
        :find-function="ShippingAddressService.getShippingAddressById",
        :label-function="(item) => `${item.street}, ${item.number} - ${item.district} - ${item.city}/${item.state} (${item.postalCode})`"
        :value-function="(item) => item.id",
        :custom-options="{ filters: [ `customerId:${customerId}` ] }"
        placeholder="Selecione o endereço de entrega"
      )

  template(slot="footer", style="text-align: right")
    el-button(type="primary", @click="promptSave", :loading="saving") Salvar

</template>
<script setup>
import RemoteSearchSelect from '@/components/input/RemoteSearchSelect.vue'

import ShippingAddressService from '@/services/ShippingAddressService'
import SubscriptionBoxOrderService from '@/services/fulfillment/SubscriptionBoxOrderService'
import SubscriptionBoxEditionService from '@/services/fulfillment/SubscriptionBoxEditionService'
import SnowflakeService from '@/services/SnowflakeService'
import VindiService from '@/services/billing/VindiService'

import { useMessage } from '@/utils/Message'
import { useConfirm } from '@/utils/MessageBox'
import { ref, reactive, watch } from 'vue'

const props = defineProps({
  customerId: {
    type: Number,
    required: true
  },
  visible: {
    type: Boolean,
    required: true
  },
})

const emit = defineEmits(['update:visible', 'created'])

const confirm = useConfirm()
const message = useMessage()

const form = ref()
const rules = ref({
  edition: [
    { required: true, message: 'Por favor, selecione a edição deste pedido', trigger: 'blur' }
  ],
  shippingAddressId: [
    { required: true, message: 'Por favor, selecione o endereço de entrega', trigger: 'blur' }
  ]
})

const data = reactive({
  edition: null,
  shippingAddressId: null
})

const saving = ref(false)
const promptSave = async () => {
  try {
    await form.value.validate()
  } catch(e) {
    message.warning("Verifique os dados preenchidos")

    return
  }

  await confirm("Você tem certeza de que deseja criar este pedido?", "Criar novo pedido", {
    confirmButtonText: 'Sim, criar pedido',
    cancelButtonText: 'Cancelar',
    type: 'warning'
  }).then(async () => {
    return await save()
  })
}

const save = async () => {
  saving.value = true

  try {
    await SubscriptionBoxOrderService.create({
      customerId: props.customerId,
      status: 'NEW',
      edition: data.edition,
      shippingAddressId: data.shippingAddressId,
      skuId: 'br.com.magenta.basic',
      additionalProducts: []
    })

    message.success("Pedido criado com sucesso")

    emit('created')
    emit('update:visible', false)
  } catch(e) {
    message.error("Não foi possível criar o pedido. Por favor, tente novamente mais tarde")

    throw e
  } finally {
    saving.value = false
  }
}

watch(() => props.visible, (newValue, oldValue) => {
  if (newValue && !oldValue) {
    data.edition = null
    data.shippingAddressId = null
  }
})
</script>
